// src/pages/LandingPage.js
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import "../App.css"; // Import the CSS file for marquee styles

const firebaseConfig = {
  apiKey: "AIzaSyB4IXgplV6A6pI8QyLmZMqUHCYQrnjBR0A",
  authDomain: "guru-granth-sahib-database.firebaseapp.com",
  projectId: "guru-granth-sahib-database",
  storageBucket: "guru-granth-sahib-database.firebasestorage.app",
  messagingSenderId: "102838898570",
  appId: "1:102838898570:web:ef67ea4d40376de01f0273",
  measurementId: "G-KXL6LMLJ40",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const LandingPage = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const [visitorCount, setVisitorCount] = useState(0); // Store visitor count

  useEffect(() => {
    const updateVisitorCount = async () => {
      try {
        const docRef = doc(db, "visitorCounter", "count");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const currentCount = docSnap.data().count || 10464;
          const newCount = currentCount + 1;
          setVisitorCount(newCount);

          // Update the count in Firestore
          await setDoc(docRef, { count: newCount }, { merge: true });
        } else {
          // If document doesn't exist, create it with the default count
          await setDoc(docRef, { count: 10464 });
          setVisitorCount(10464);
        }
      } catch (error) {
        console.error("Error updating visitor count:", error);
      }
    };

    updateVisitorCount();
  }, []);

  const guruNames = [
    "ੴ",
    "ਸਤਿ ਨਾਮੁ",
    "ਕਰਤਾਂ ਪੁ੍ਰਖ",
    "ਨਿਰਭਉ",
    "ਨਿਰਵੈਰ",
    "ਅਕਾਲ ਮੂਰਤਿ",
    "ਅਜੂਨੀ",
    "ਸੈਭੰ",
    "ਗੁਰ ਪ੍ਰਸਾਦਿ",
    "ਜਪੁ",
    "ਆਦਿ",
    "ਸਚੁ",
    "ਜਪੁ",
    "ਹਰਿ",
    "ਗੁਰੁ",
    "ਵਾਹਿਗੁਰੂ",
  ];

  // Function to toggle music playback
  const toggleMusic = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="bg-gradient-to-br from-orange-400 via-orange-500 to-indigo-900 min-h-screen flex flex-col items-center justify-center text-white px-4 py-6">
      {/* Infinite Scrolling Guru Names Banner */}
      <div className="marquee-container w-full overflow-hidden mb-4">
        <div className="marquee">
          {guruNames.map((guru, index) => (
            <span key={index} className="marquee-item text-xl sm:text-2xl md:text-3xl">
              {guru}
            </span>
          ))}
          {guruNames.map((guru, index) => (
            <span key={`copy-${index}`} className="marquee-item text-xl sm:text-2xl md:text-3xl">
              {guru}
            </span>
          ))}
        </div>
      </div>

      {/* Ek Onkar Image */}
      <motion.div
        className="mb-4 sm:mb-8 w-32 h-32 sm:w-40 sm:h-40 md:w-auto md:h-auto"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.2 }}
      >
        <img src="/Ekonkar.jpg" alt="Ek Onkar" className="w-full h-full rounded-full" />
      </motion.div>

      {/* Play Music Button */}
      <motion.div
        className="mb-4 sm:mb-6"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, delay: 0.3 }}
      >
        <button
          onClick={toggleMusic}
          className="px-4 sm:px-6 py-2 sm:py-3 bg-orange-600 hover:bg-orange-800 rounded-lg text-sm sm:text-lg font-semibold shadow-lg transform hover:scale-105 transition duration-300"
        >
          {isPlaying ? "Pause Kirtan" : "Play Kirtan"}
        </button>
        <audio ref={audioRef} src="music.mpeg" loop />
      </motion.div>

      {/* Heading */}
      <motion.h1
        className="text-2xl sm:text-4xl md:text-6xl font-bold text-center mb-3 sm:mb-6"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, delay: 0.5 }}
      >
        The Eternal Guru
      </motion.h1>

      {/* Subtitle */}
      <motion.p
        className="text-base sm:text-lg md:text-xl text-center max-w-2xl mb-6 sm:mb-8"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, delay: 0.7 }}
      >
        AI Chatbot based on Sri Guru Granth Sahib Ji
      </motion.p>

      {/* Launch Chatbot Button */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.2, delay: 1 }}
      >
        <Link to="/chatbot">
          <button className="px-4 sm:px-6 py-2 sm:py-3 bg-orange-600 hover:bg-orange-800 rounded-lg text-sm sm:text-lg font-semibold shadow-lg transform hover:scale-105 transition duration-300">
            Ask the Eternal Guru
          </button>
        </Link>
      </motion.div>

      {/* Visitor Counter */}
      <div className="mt-4 text-black rounded-lg shadow-lg" style={{background: "transparent"}}>
        <h2 className="text-lg sm:text-xl font-semibold">Visitor Count: {visitorCount}</h2>
      </div>

      {/* <div className="utu_div mt-8">
        <h3 className="utu_Name">Developed By:</h3>
        <img src="/utu.png" className="utuImg" alt="UTU Logo" />
        <h3 className="utu_Name">
          VMSB Uttarakhand Technical University, Dehradun
        </h3>
      </div> */}
    </div>
  );
};

export default LandingPage;
